module.exports = __webpack_public_path__ + "img/88.d686bf57.jpg";